import React, { useEffect } from "react";
import { createPortal } from "react-dom";

/** Right-side slide-in drawer used for the navigation menu. */
const Drawer = ({ open, onClose, children }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-slate-900/40 animate-fade-in" onClick={onClose} />
      <div className="absolute right-0 top-0 flex h-full w-72 max-w-[82%] flex-col bg-white shadow-2xl animate-drawer-in">
        {children}
      </div>
    </div>,
    document.body,
  );
};

export default Drawer;
